<template>
  <div>
    <v-select
      label="name"
      v-model="selectedLocation"
      :filterable="false"
      :options="listLocation"
      @search="searchLocation"
      :placeholder="placeholder ? placeholder : `${translations[13589]}...`"
      :dir="isRtl"
      class="form-control"
      :class="[{'form-control-lg': lg, 'border-0': border}]"
      :autoscroll="false"
    >
      <template slot="no-options">
        {{ translations[10432] }}
      </template>
      <template slot="option" slot-scope="listLocation">
        <div class="text-left">
          {{ listLocation.name || listLocation.description }}
        </div>
      </template>
    </v-select>
  </div>
</template>

<script lang="ts">
import {
  Component, Vue, Prop,
} from 'vue-property-decorator';
import axios from 'axios';
import { ProfessionModule } from '@/store/modules/profession';
import { JobType } from '@/types/ProfessionType';
import { AppModule } from '@/store/modules/app';

@Component
export default class SelectLocation extends Vue {
  @Prop({ default: () => ({} as any) }) value!: any;

  @Prop({ default: false }) lg!: boolean;

  @Prop({ default: false }) border!: boolean;

  @Prop({ default: '' }) placeholder!: string;

  get translations() {
    return AppModule.translation;
  }

  get isRtl() {
    return AppModule.rtl;
  }

  listLocation = [];

  private load: any;

  cancel: any = null;

  searchText: string | undefined;

  get languageSid() {
    return AppModule.languageSid;
  }

  get selectedLocation() {
    return this.value;
  }

  set selectedLocation(value: any) {
    this.$emit('input', value);
    this.$emit('change');
  }

  async loadLocationOptions(query: string) {
    try {
      const { CancelToken } = axios;
      // let cancel;
      await axios
        .get(
          `${
            process.env.VUE_APP_API_URL ? process.env.VUE_APP_API_URL : '/v1'
          }/jobnews/location_query`,
          {
            params: {
              sid: this.languageSid,
              q: query,
              jobnews_type: 1,
            },
            cancelToken: new CancelToken((c) => {
              this.cancel = c;
            }),
          },
        )
        .then((res) => {
          this.listLocation = res.data[0].res && res.data[0].res.length ? res.data[0].res : res.data;
          this.load(false);
        })
        .catch((thrown) => {
          if (axios.isCancel(thrown)) {
            this.load(true);
          }
        });
    } catch (error) {
      console.error(error);
    }
  }

  searchLocation(searchText: string, loading: any) {
    this.load = loading;
    if (searchText.trim().length > 2) {
      this.searchText = searchText;
      this.load(true);
      if (this.cancel) {
        this.cancel();
      }
      this.loadLocationOptions(searchText).then((r) => {
        if (this.searchText === searchText) {
          this.load(false);
        }
      });
    } else {
      if (this.cancel) this.cancel();
      this.listLocation = [];
      this.load(false);
    }
  }
}
</script>
